import usePageTitle from "../hooks/usePageTitle";

function TermsOfService() {
  usePageTitle(`Terms of Service | Fudopia | Meet. Eat. Repeat.`);

  return (
    <section>
      <h1>Terms of Service</h1>
      <div>
        <p>Last updated: 21st of May, 2025</p>
      </div>
      <div className="section terms-conditions">
        <div>
          <h3>1. Who can join Fudopia?</h3>
          <p>
            You must be at least <strong>20 years old</strong> to use Fudopia.
            By signing up, you confirm that you meet this age requirement.
          </p>
        </div>

        <div>
          <h3>2. What does Fudopia offer?</h3>
          <p>
            Fudopia helps people connect through small foodie meetups. You can
            browse dishes and drinks, join events, or create your own (with a
            subscription). <br />
            The first 200 users enjoy{" "}
            <strong>free access for a full year</strong>.
          </p>
        </div>

        <div>
          <h3>3. What are the community rules?</h3>
          <p>
            Be kind, respectful, and inclusive. Harassment, hate speech, or
            inappropriate behavior is not allowed. We're all here for the food,
            the fun, and the friendly vibes.
          </p>
        </div>

        <div>
          <h3>4. Who is responsible for events?</h3>
          <p>
            Fudopia facilitates connections, but users host the events. We are
            not liable for anything that happens during or outside of meetups.
            Hosts should confirm restaurant or café details in advance, and
            everyone should always prioritize their safety.
          </p>
        </div>

        <div>
          <h3>4.1 Can I bring a friend who isn't on Fudopia?</h3>
          <p>
            To keep events safe and enjoyable, only people who have officially
            joined the event through Fudopia are allowed to attend. Please don’t
            bring extra guests or invite others outside the platform. Everyone
            should have their own account and join individually.
          </p>
        </div>

        <div>
          <h3>4.2 Who pays at the restaurant?</h3>
          <p>
            Each attendee is responsible for covering their own food, drinks, or
            anything else they consume. Fudopia does not handle or get involved
            in any payment arrangements between users or venues.
          </p>
        </div>

        <div>
          <h3>4.3 Can I report someone for bad behavior?</h3>
          <p>
            Yes! If someone acts inappropriately or makes you feel
            uncomfortable, please let us know. We’ll look into the situation and
            take action if needed. That said, Fudopia doesn't pre-screen users
            or guarantee any particular behavior — so always use your best
            judgment and prioritize your well-being.
          </p>
        </div>

        <div>
          <h3>4.4 What about Girls Meetups or Guys Meetups?</h3>
          <p>
            Some events are labeled as a “Girls Meetup” or “Guys Meetup” to set
            a certain vibe. These labels are chosen by the event creator and
            reflect who the event is intended for.
          </p>
          <p>
            We ask everyone to respect the spirit of these meetups. For example,
            if an event is listed as a “Girls Meetup,” please only join if you
            identify as a woman.
          </p>
          <p>
            Fudopia doesn’t actively verify these labels, but we expect all
            users to participate respectfully and consider the group dynamic
            when joining events.
          </p>
        </div>

        <div>
          <h3>5. How does event creation work?</h3>
          <p>
            If you want to create a new event, the soonest available date will
            be two days from today. This gives others a chance to discover your
            event and avoids last-minute no-shows.
          </p>
          <p>
            All submitted events go through a quick review before being
            published. This usually only takes a few hours. Once approved, your
            event will appear on the Events page — and sometimes it might even
            be featured on the homepage (that part’s totally up to us!).
          </p>
        </div>

        <div>
          <h3>6. Can users upload content?</h3>
          <p>
            Not yet! At this stage, users can’t post photos or upload profile
            pictures. You’re only responsible for your text-based info, like
            your username, bio, and favorite food.
          </p>
        </div>

        <div>
          <h3>7. What profile information is shared?</h3>
          <p>
            Only your <strong>username</strong>, <strong>bio</strong>, and{" "}
            <strong>favorite food</strong> are shared with other users. We do
            not share your email address or any sensitive data.
          </p>
        </div>

        <div>
          <h3>8. Will these terms ever change?</h3>
          <p>
            Possibly! If we update our Terms of Service, we’ll let you know
            through the platform. Major changes will be communicated clearly.
          </p>
        </div>

        <div>
          <p>
            Still unsure about something?{" "}
            <a href="/contact" style={{ textDecoration: "underline" }}>
              Reach out to us
            </a>
            , we’re happy to help.
          </p>
        </div>
      </div>
    </section>
  );
}

export default TermsOfService;
